import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MessagesList from './MessagesList';
import CollapseButton from './CollapseButton';

import './CarrierMessages.module.scss';

class CarrierMessages extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: props.defaultCollapsed
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      collapsed: nextProps.defaultCollapsed,
    });
  }

  onButtonClick = () => {
    this.setState({collapsed: !this.state.collapsed});
  };

  renderMessagesList() {
    const {
      data,
      count,
      fullDate,
      isMobile,
      designSettings,
      locale,
    } = this.props;

    const props = {
      isMobile,
      fullDate,
      designSettings,
      locale,
      data: data.slice().sort((a, b) => {
        const first = new Date(a.messageDate);
        const second = new Date(b.messageDate);
        return second - first;
      }).slice(0, count) // count recent messages
    };

    return <MessagesList {...props} /> ;
  }

  render() {
    const {
      collapsed,
    } = this.state;

    const {
      isMobile,
      designSettings,
      showHistoryLabel,
      hideHistoryLabel,
      designSettings: {
        bodyBackgroundColor,
        carrierMessagesBackgroundColor,
      },
    } = this.props;

    const styleName = classNames('messages', {
      mobile: this.props.isMobile,
    });

    return (
      <div
        styleName={styleName}
        style={{ backgroundColor: carrierMessagesBackgroundColor }}
      >
        { !collapsed && this.renderMessagesList() }
        <div styleName="bottom">
          <CollapseButton
            isMobile={isMobile}
            collapsed={collapsed}
            onClick={this.onButtonClick}
            designSettings={designSettings}
            showHistoryLabel={showHistoryLabel}
            hideHistoryLabel={hideHistoryLabel}
          />
          <div
            styleName="shadow"
            style={{ backgroundColor: bodyBackgroundColor }}
          />
        </div>
      </div>
    );
  }
}

CarrierMessages.defaultProps = {
  data: [],
  count: 5,
  defaultCollapsed: true,
};

CarrierMessages.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  count: PropTypes.number,
  defaultCollapsed: PropTypes.bool,
  fullDate: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  designSettings: PropTypes.object.isRequired,
  showHistoryLabel: PropTypes.string,
  hideHistoryLabel: PropTypes.string,
  locale: PropTypes.string,
};

export default CarrierMessages;